import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/nf/notasfiscais/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findNotas(
  empresa_cnpj,
  id,
  include,
  where = {},
  between = "",
  sort = ""
) {
  let query = "";
  Object.keys(where).forEach((value, index) => {
    query += `&where[${value}]=${where[value]}`;
  });
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }${query}${between ? `&${between}` : ""}${
      sort ? `&sort=${sort}` : ""
    }&per_page=100`,
    "GET",
    headers
  );
}

export async function logsNota(empresa_cnpj, nfeId) {
  return search(
    `${path}/${nfeId}/logs?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}

export async function updateXml(empresa_cnpj, nfeId, body) {
  return search(
    `${path}/updatexml/${nfeId}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export async function createNota(empresa_cnpj, body, include, usuario_id) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&usuario_id=${usuario_id}${
      include ? `&include=${include}` : ""
    }`,
    "POST",
    headers,
    body
  );
}

export async function updateNota(empresa_cnpj, id, body, include, usuario_id) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}&usuario_id=${usuario_id}${
      include ? `&include=${include}` : ""
    }`,
    "PUT",
    headers,
    body
  );
}

export function cancelarNota(empresa_cnpj, id, body) {
  return search(
    `${path}/cancel/${id}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export function downloadXmlNota(empresa_cnpj, nfeIds = []) {
  let queryIds = "";
  nfeIds.forEach((element) => {
    queryIds += `&id[]=${element}`;
  });

  return search(
    `${process.env.REACT_APP_URL_API_ERP}/erp/nf/notasfiscais/v1/downloadsxmls?empresa_cnpj=${empresa_cnpj}${queryIds}`,
    "GET",
    headers
  );
}

export async function transmit(empresa_cnpj, nfeId) {
  return search(
    `${path}/transmit/${nfeId}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers
  );
}

export async function downloadDanfe(empresa_cnpj, nfeId, body) {
  return search(
    `${path}/danfe/${nfeId}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export function sendMail(empresa_cnpj, body) {
  return search(
    `${path}/sendemail?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function downloadArchives({ empresa_cnpj, body }) {
  return search(
    `${path}/downloadarchives?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function financialType(empresa_cnpj, nfeId) {
  return search(
    `${path}/tipo-financeiro/${nfeId}?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}
